import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/site";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-background-200 bg-secondary-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-table-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </span>
              <span className="text-base font-bold text-foreground-900">{t("brand.name")}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">{t("brand.tagline")}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">Explore</h4>
            <div className="mt-4 flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
              >
                {t("footer.home")}
              </Link>
              <Link
                to="/guides/allchinabuy-spreadsheet-guide"
                className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
              >
                {t("footer.guide")}
              </Link>
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
              >
                {t("nav.buyNow")}
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">{t("nav.safety")}</h4>
            <p className="mt-4 text-xs leading-relaxed text-foreground-500">
              {t("footer.disclaimer")}
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {t("brand.name")}. {t("footer.rights")}
          </p>
          <p className="text-xs text-foreground-400">
            allchinabuyspread.uk
          </p>
        </div>
      </div>
    </footer>
  );
}